import React from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Button, Typography } from '@guildeducationinc/recess';
import ChevronRightIcon from '@guildeducationinc/recess/icons/ChevronRightIcon';
import { ComponentDataKey } from '@src/components/Pages/Home/Layout/config';
import { useEmployerContent } from '@src/context/EmployerContentContext';
import { MOBILE_QUERY } from '@src/constants';
import { clickable } from '@src/analytics';
import './ReimbursementCallout.scss';
import { useIsTablet } from '@src/utilities/screenResizeUtility';

const ReimbursementCallout: React.FC = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  const dataKey = ComponentDataKey.STUDENT_LOAN;
  const { [dataKey]: content } = useEmployerContent() ?? {};

  const reimbursementClickable = () => {
    clickable({
      loggedIn: true,
      product: 'home',
      tag: 'student_loan_modal',
      text: 'explore_tuition_reimbursement',
      type: 'link',
    });
  };

  const tablet = useIsTablet();

  const reimbursementCalloutContainer = classnames(
    'reimbursementModal',
    'reimbursementCalloutColor',
    'flex',
    'flexDirection--column',
    'margin--top_24',
    'padding--top_16'
  );

  const reimbursementCalloutContent = classnames(
    'flex',
    'padding--x_16',
    !isMobile && 'flexItems--center'
  );

  const reimbursementCalloutTextWrapper = classnames(
    'flex',
    'flexDirection--column',
    'padding--left_16'
  );

  const reimbursementCalloutLabel = classnames(
    'fontWeight--600',
    'margin--bottom_4',
    'margin--top_0'
  );

  const reimbursementCalloutLink = classnames(
    isMobile && 'exploreReimbursementButton',
    tablet && 'margin--left_0'
  );

  return (
    <div className={reimbursementCalloutContainer}>
      <div className={reimbursementCalloutContent}>
        <div className={reimbursementCalloutTextWrapper}>
          <Typography className={reimbursementCalloutLabel} Component='p'>
            {content?.reimbursementCallout.title}
          </Typography>
          <Typography variant='body1'>{content?.reimbursementCallout.body}</Typography>
        </div>
      </div>
      <div className={reimbursementCalloutLink}>
        <Button
          appearance='ghost'
          fullWidth={isMobile}
          href={content?.reimbursementCallout.button.href}
          icon={<ChevronRightIcon size={24} />}
          iconDirection='right'
          onClick={reimbursementClickable}
        >
          {content?.reimbursementCallout.button.text}
        </Button>
      </div>
    </div>
  );
};

export default ReimbursementCallout;
